import React from "react";
import "../styles/TopBanner.css";


const TopBanner = () => {
  return (
  <div className="top-banner">
    <button onClick={() => window.location.href='/'}>Home</button>
  </div>
  );
};

export default TopBanner;